/**
 * Szerokość treści ekranu w układzie panelu (`CustomLayout.tsx`) — osobno,
 * żeby dało się ją sprawdzić testem bez stawiania układu react-admina.
 */

/** Odstęp treści ekranu od menu i od prawej krawędzi (`RaLayout-content`, po 8 px). */
export const CONTENT_PADDING_X = 8;

/** Opakowanie tabeli listy: przewija się samo i nie poszerza strony. */
export const DATAGRID_WRAPPER_SX = { overflowX: 'auto', width: 0, minWidth: '100%' } as const;

/**
 * Układ panelu nie rośnie ponad okno (29.10.2026, przegląd wyglądu na różnych
 * rozdzielczościach). react-admin daje korzeniowi układu `min-width:
 * fit-content`, więc szeroka tabela poszerzała całą stronę; dawne ograniczenie
 * treści `calc(100vw - menu)` nie odejmowało odstępów treści (2 × 8 px) ani
 * paska przewijania strony — treść dobita do niego była o 16–17 px szersza od
 * okna (przy 1024 px kilka list, przy 1280 px karta zlecenia Trade
 * z przewoźnikami). Teraz korzeń i treść mają `min-width: 0`, a treść
 * najwyżej 100% — szerokie tabele przewijają się w swoich opakowaniach
 * (`overflowX: auto`), które dopiero teraz mają ograniczoną szerokość.
 */
export const LAYOUT_NO_GROW_SX = { minWidth: '0 !important' } as const;

/** Treść ekranu (`RaLayout-content`, element flex obok menu) też nie rośnie ponad miejsce. */
export const CONTENT_NO_GROW_SX = { minWidth: 0 } as const;

/** Najszersza treść ekranu (`wsp-tresc`): tyle, ile daje układ. */
export const CONTENT_MAX_WIDTH = '100%';

/**
 * Wąskie okno (29.10.2026, decyzja Bartka: „1024 px — zrób tak, żeby było
 * dobrze i czytelnie”): poniżej 1280 px menu boczne zwija się do ikon,
 * a listy robocze łączą drugorzędne kolumny w jedną komórkę. Od 1280 px
 * wszystko jak dotąd.
 */
export const NARROW_LAYOUT_MAX_PX = 1279;

/** Zapytanie CSS wąskiego okna — to samo w hooku i w testach. */
export const NARROW_LAYOUT_QUERY = `(max-width:${NARROW_LAYOUT_MAX_PX + 0.95}px)`;

/** Stan menu bocznego: otwarte i czy zwinęło je wąskie okno (a nie użytkownik). */
export interface SidebarWidthState {
  open: boolean;
  autoCollapsed: boolean;
}

/**
 * Menu przy zmianie szerokości okna. Wejście w wąskie okno zwija otwarte
 * menu i zapamiętuje, że zrobiło to okno; wyjście z wąskiego otwiera je
 * z powrotem tylko wtedy — menu zwinięte przez użytkownika zostaje zwinięte.
 * W wąskim oknie użytkownik może menu rozwinąć przyciskiem (☰) — reguła
 * działa tylko na zmianę szerokości, więc go nie zwija.
 */
export function sidebarOnWidthChange(narrow: boolean, state: SidebarWidthState): SidebarWidthState {
  if (narrow) return state.open ? { open: false, autoCollapsed: true } : state;
  return state.autoCollapsed ? { open: true, autoCollapsed: false } : state;
}
